import type { HTMLAttributes, ReactNode } from 'react';

import styles from './_index.module.scss';

export interface SideToolbarProps extends HTMLAttributes<HTMLDivElement> {
  tools: ReactNode[];
}

const SideToolbar = ({ className, tools, ...props }: SideToolbarProps) => {
  return (
    <div {...props}>
      {tools.length > 0 && (
        <ul className={styles['side-toolbar-tools']}>
          {tools.map((tool, index) => (
            <li key={index}>{tool}</li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default SideToolbar;
